export default "__VITE_ASSET__XBsalixh__"